import { Container } from "@mui/material";
import BloqueVista from "../../components/public/BloqueVista";

/**
 * Home público (landing). El contenido vive en el Bloque "home" (editable por
 * staff en el admin); aquí solo se le pone el contenedor del sitio público.
 * Dentro de la app, el mismo bloque se ve en `pages/app/Inicio`.
 */
export default function Home() {
  return (
    <Container maxWidth={false} sx={{ maxWidth: 820, py: { xs: 5, md: 7 }, minHeight: "55vh" }}>
      <BloqueVista clave="home" />
    </Container>
  );
}
